
<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Comissões Venda Direta</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
          <div class="row">
              <div class="col-md-12">
                  <h3 class="box-title first">Comissões venda Direta</h3>
              </div>
          </div>
          <div class="alert alert-danger" role="alert">
              <p>
                  Alteração da Razão Social : DESCARBONIZE SOLUCOES S.A.  <b>S/A</b> ( Tomador dos Serviços)
              </p>
          </div>
          <div class="row">
              <div class="col-xs-12 col-md-2">
                  <FormHelper :inputVar="formFilter.dataInicial"
                              :value="dateInitDefault"
                              :form="formFilter"
                              validationType="pastDate"
                              label="Data Inicial"
                              icon="fa-calendar"
                              mask="##/##/####"></FormHelper>
              </div>
              <div class="col-xs-12 col-md-2">
                  <FormHelper :inputVar="formFilter.dataFinal"
                              :value="dateFinishDefault"
                              :form="formFilter"
                              validationType="pastDate"
                              label="Data Final"
                              icon="fa-calendar"
                              mask="##/##/####"></FormHelper>
              </div>
              <div class="col-xs-12 col-md-3">
                  <FormHelper :inputVar="formFilter.situacao"
                              :form="formFilter"
                              :options="getStatus()"
                              :selected="situacaoDefault"
                              type="select"
                              label="Situação"
                              placeholder="Selecione"></FormHelper>
              </div>
              <div class=" col-xs-12  col-md-2 col-only-button">
                  <button aria-label="Pesquisar" id="btn-search" class="btn primary-button stretch" v-on:click="search">
                      <i id="btn-icon" class="fa fa-search"></i> Pesquisar
                  </button>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <h3 class="box-title first">Posição Financeira</h3>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <div class="wrapper-table-scroll-mobile">
                      <table class="table table-condensed table-responsive">
                          <thead>
                              <tr>
                                  <th class="text-center" v-for="(column, index) in columns" :key="'header' + index">
                                      {{column.label}}
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(row, index) in rows" :key="'row' + index">
                                  <td :class="getCellClassStatus(row)" v-for="(item, childrenIndex) in row" :key="'item' + childrenIndex">
                                      <span v-if="item.bold">
                                          <strong>{{item.value}}</strong>
                                      </span>
                                      <span v-else-if="item.href">
                                          <a :href="item.href">{{item.value}}</a>
                                      </span>
                                      <span v-else>
                                          <span v-if="childrenIndex == '12'">
                                              {{ getCellFormatValue(item.value) }}
                                          </span>
                                          <span v-else v-html="item.value"></span>
                                      </span>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          
          <div class="row">
              <div class="col-md-12">
                  <h3 class="box-title">Comissões venda Direta</h3>
              </div>
              <div class="col-md-12">
                  <p>Os pagamentos serão feitos através de depósito bancário em conta jurídica da empresa emissora.</p>
                  <p>
                      <strong>Indique no próprio corpo da Nota Fiscal de Prestação de Serviço os dados completos (banco,agência,conta corrente) para depósito bancário.</strong>
                  </p>
                  <p>O pagamento será efetuado em até 07(sete) dias úteis a partir do recebimento da Nota Fiscal.</p>
                  <p>
                      <strong>IMPORTANTE:</strong> Conforme cláusulas  7.7, 7.8 e 7.9 do Contrato Comercial de Revendas ALDO, os pagamentos ficam liberados por 90 dias
                      corridos, com a liberação para emissão de NF para recebimento, sempre no primeiro dia útil do mês subsequentes à quitação integral da nota
                      fiscal de venda pela ALDO. Após esse período comissões são automaticamente excluídas de nosso sistema.
                  </p>
                  <p>
                      Clique no link abaixo para verificar sobre o preenchimento da Nota Fiscal de Prestação de Serviço:
                  </p>
              </div>
          </div>

          <div class="row">
              <div class="col-md-12">
                  <BulmaAccordion :dropdown="false" :icon="'custom'">
                      <BulmaAccordionItem>
                          <h4 slot="title" style="color: blue"><link><u>EMISSÃO DA NOTA FISCAL DE PRESTAÇÃO DE SERVIÇO - CLIQUE AQUI</u></link></h4>
                          <div slot="content">
                              <div class="form-nested-accordion">
                                  <div class="row">
                                      <div class="col-md-12">
                                          <p>Observar as seguintes mudanças no preenchimento da Nota Fiscal de Prestação de Serviço:</p>

                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> Descrição do serviço
                                          </p>
                                          <p class="azul text-center">"PROMOÇÃO DE VENDAS CONFORME NOTAS(S) FISCAL(IS) N° XXXX / XXXX / XXXX"</p>
                                          <p align="center">
                                              <small>
                                                  <em>(Preencher com o número das(s) Fiscal(is) da ALDO que originou(aram) a cobrança)</em>
                                              </small>
                                          </p>

                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> Item do serviço
                                          </p>
                                          <p>Nos municípios que exigem a informação do item do serviço constante na Lei Complementar 116/2003, deverá ser apontado:</p>
                                          <p>
                                              <em>17 - Serviços de apoio técnico, administrativo, jurídico, contábil, comercial e congêneres.</em>
                                          </p>
                                          <p>
                                              <em>17.06 - Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários.</em>
                                          </p>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-md-7">
                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> CFOP
                                          </p>
                                          <p>Se emitir Nota Fiscal MODELO 55 (Nota Fiscal Eletrônica - DANFE), utilize:</p>
                                          <p>- CFOP 5.933 para remetentes do mesmo Estado</p>
                                          <p>- CFOP 6.933 para remetentes de outros Estados</p>
                                          <p>Descrição do CFOP: Prestação de serviço tributado pelo ISS</p>
                                      </div>
                                      <div class="col-md-5">
                                          <img src="/assets/images/nfe.png" style="height:120px;">
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-md-12">
                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> Retenção de Tributos:
                                          </p>
                                          <p>EMPRESAS DO LUCRO REAL E LUCRO RESUMIDO</p>
                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> Para serviços prestados com valor superior a R$ 666,66, deverá ser retirada:
                                          </p>
                                          <p>- IRRF (Impostos de Renda Retido na Fonte), no percentual de 1,5%</p>
                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> EMPRESAS DO SIMPLES NACIONAL
                                          </p>
                                          <p>Empresas do SIMPLES NACIONAL deverão seguir todos os procedimentos expostos, exceto o da Retenções de Tributos, a qual está dispensada conforme art. 1° da IN 765/2007 e Art .3° da IN 459/2004.</p>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-md-8">
                                          <p class="advanced-title">
                                              <i class="fa fa-angle-double-right" aria-hidden="true"></i> Período de apuração das comissões:
                                          </p>

                                          <p>Sempre aguarde o fechamento do mês corrente para então emitir uma única Nota Fiscal de Prestação de Serviçoes, que englobe os valores de todas as comissões que estejam com o status "LIBERADO" PARA PAGAMENTO.</p>
                                      </div>
                                      <div class="col-md-4 text-center">
                                          <i class="fa fa-4x fa-calendar"></i>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-md-12">
                                          <p>
                                              <strong>
                                                  Não inclua valores
                                                  <span class="azul">"NÃO LIBERADOS"</span> para pagamento;
                                              </strong> se incluir, sua nota fiscal ficará pendente de pagamento até que todos os valores estejam com status "LIBERADO" para pagamento.
                                          </p>
                                          <p>
                                              <small>
                                                  <em>O motivo é facilitar o recolhimento dos tributos, já que a apuração dos valores considera todas as Notas Fiscais de Prestação de Serviços emitidas para a ALDO dentro do mesmo mês. (exemplo: se sua empresa emitiu dentro do mesmo mês três notas fiscais de prestação de serviços para recebimento de comissões, o cálculo dos tributos deverá ser feito considerando-se a soma dos valores destas três notas). Por isso, para facilitar orientamos que aguarde o fechamento do mês e emita apenas uma nota fiscal.</em>
                                              </small>
                                          </p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </BulmaAccordionItem>
                  </BulmaAccordion>
              </div>
          </div>

          <div class="row">
              <div class="col-md-12">
                  <h3>FORMA DE ENVIO DA NOTA FISCAL DE PRESTAÇÃO DE SERVIÇOS</h3>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <p class="advanced-title">
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i> Para Notas Fiscais ELETRÔNICAS (Modelo 55)
                  </p>
                  <p>Sua Nota Fiscal Eletrônica deverá ser enviada para nós através do site.</p>
                  <p>Clique no link abaixo para fazer upload da sua nota fiscal:</p>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <BulmaAccordion :dropdown="false" :icon="'custom'">
                      <BulmaAccordionItem>
                          <h4 slot="title" style="color: blue"><link><u>Upload da Nota Fiscal E XML de Prestação de Serviço</u></link></h4>
                          <div slot="content">
                              <div class="form-nested-accordion">
                                  <div class="row">
                                      <div class="col-md-10">
                                          <FormHelper :inputVar="formFilter.file"
                                                      :form="formFilter"
                                                      type="file"
                                                      label="Arquivo"
                                                      id="files"
                                                      placeholder="Clique aqui para selecionar o arquivo"></FormHelper>
                                      </div>
                                      <div class="col-md-2 col-only-button">
                                          <Loader v-if="isUploading" />
                                          <button v-else aria-label="Enviar" id="btn-upnf" class="btn primary-button stretch" v-on:click="uploadNf" disabled="true">Enviar</button>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-md-12">
                                          <div class="alert alert-warning"
                                               role="alert">Envie apenas arquivos com as extensões .jpg, .gif, .png, .pdf ou .xml, com no máximo 2MB</div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-md-12">
                                          <p>De acordo com o § 7º do artigo 7º do Anexo IX do Regulamento do ICMS (§ 7º da cláusula sétima do Ajuste SINIEF 07/05), o emitente de Nota Fiscal eletrônica deve, obrigatoriamente, encaminhar ou disponibilizar download do arquivo XML da NF-e (com seu respectivo Protocolo de Autorização de Uso) ao destinatário, imediatamente após o recebimento da autorização de uso da NF-e. Essa exigência é de caráter nacional e foi estabelecida pelo Ajuste SINIEF 11/08, publicado no Diário Oficial da União em 01/10/2008.</p>
                                          <p>
                                              <strong>
                                                  "§ 7º O emitente da NF-e deverá, obrigatoriamente, encaminhar ou disponibilizar download do arquivo da NF-e e seu respectivo Protocolo de Autorização de Uso ao destinatário,
                                                  <u>imediatamente após o recebimento da autorização de uso da NF-e."</u>
                                              </strong>
                                          </p>
                                          <div class="alert alert-danger" role="alert">
                                              <p>
                                                  <strong>O não cumprimento dessa obrigação tributária acessória sujeita o infrator às penalidades previstas na Lei 11.580/96.</strong>
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </BulmaAccordionItem>
                  </BulmaAccordion>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <p class="advanced-title">
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i> Para Notas Fiscais NÃO-ELETRÔNICAS
                  </p>
                  <p>Sua Nota Fiscal deverá ser encaminhada PELOS CORREIOS para a sede da ALDO:</p>
                  <p class="advanced-title">
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i> Endereço para envio:
                  </p>
                  <p>
                    Descarbonize Soluções S/A - A/C Financeiro
                      <br>Av. Advogado Horácio Raccanello Filho, 1836 - Vila Nova
                      <br>Maringá/PR CEP: 87.045-237
                  </p>
              </div>
          </div>

      </div>
    </div>
  </main>
</template>

<script>
    import "vue-good-table/dist/vue-good-table.css";

    import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
    import FormHelper from "./partials/FormHelper.vue";
    import Loader from './partials/Loader';

    export default {
        name: "DirectSaleCommission",
        components: {
            FormHelper,
            BulmaAccordion,
            BulmaAccordionItem,
            Loader
        },
        data() {
            return {
                isUploading: false,
                formFilter: {
                    attemptSubmit: false,
                    dataInicial: new this.formInput(false),
                    dataFinal: new this.formInput(false),
                    situacao: new this.formInput(false),
                    file: new this.formInput(false)
                },
                columns: [
                    { label: "Ped. Internet / ALDO:" },
                    { label: "Nota Fiscal" },
                    { label: "Data NF" },
                    { label: "Vencimento" },
                    { label: "Quitação" },
                    { label: "Valor NF" },
                    { label: "CNPJ" },
                    { label: "Cidade" },
                    { label: "Total Pagar" },
                    { label: "Situação" },
                    { label: "Nf. Prest." },
                    { label: "Data Quit." },
                    { label: "Sit.Upload" }
                ],
                rows: []
            };
        },
        watch: {
            "formFilter.file.value": function (val) {
                if (val.length > 0) {
                    this.enableUpload();
                } else {
                    this.disableUpload();
                }
            }
        },
        computed: {
            formErrors: function () {
                // Retorna os campos que estão com erro de validação
                const errors = Object.keys(this.formFilter).filter((key) => this.formFilter[key].validation && !this.formFilter[key].validation.status)
                return errors.length;
            },
            dateInitDefault: function () {
                var d = new Date(this.returnDate(90));
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();
                return (this.formFilter.dataInicial.value = datestring);
            },
            dateFinishDefault: function () {
                var dtNow = new Date();

                var d = new Date();

                //formata data para padrao dd/mm/yyyy
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();

                return (this.formFilter.dataFinal.value = datestring);
            },
            situacaoDefault: function () {
                return (this.formFilter.situacao.value = "Todos");
            }
        },
        mounted: function () {
            this.fillTable({});
            this.disableUpload();
            this.search();
        },
        methods: {
            getCellClassStatus(strStatus) {
                var status = strStatus[12];
                if (strStatus[12] != undefined && status.value != undefined) {
                    if (status.value == "CNAE_DIVERGENTE")
                        return 'is-cnae_divergente';
                    else if (status.value == "SEM_INFORMACOES_BANCARIAS")
                        return 'is-seminformacaobancaria';
                    else if (status.value == "SEM_DESTAQUE_DE_IRPJ")
                        return 'is-semdestaqueirpj';
                    else if (status.value == "SEM_REGISTRO_DE_NF_DE_VENDA")
                        return 'is-semregistronfvenda';
                    else if (status.value == "VALOR_DO_PREMIO_DIVERGENTE")
                        return 'is-valorpremiodivergente';
                    else if (status.value == "DADOS_DO_TOMADOR_DIVERGENTE")
                        return 'is-dadostomadordivergente';
                    else if (status.value == "SEM_CNAE_HABILITADO")
                        return 'is-semcnaehabilitado';
                    else if (status.value == "COD_DE_SERVICO_DIVERGENTE_DO_CNAE")
                        return 'is-codservicodivergentecnae';
                    else 
                        return 'is-ok';
                }
                else {
                    return 'is-ok';
                }
                
                
            },
            getCellFormatValue(strStatus) {
                if (strStatus != undefined) {
                    if (strStatus == "CNAE_DIVERGENTE")
                        return 'CNAE DIVERGENTE';
                    else if (strStatus == "SEM_INFORMACOES_BANCARIAS")
                        return 'SEM INFORMAÇÕES BANCÁRIAS';
                    else if (strStatus == "SEM_DESTAQUE_DE_IRPJ")
                        return 'SEM DESTAQUE DE IRPJ';
                    else if (strStatus == "SEM_REGISTRO_DE_NF_DE_VENDA")
                        return 'SEM REGISTRO DE NF DE VENDA';
                    else if (strStatus == "VALOR_DO_PREMIO_DIVERGENTE")
                        return 'VALOR DO PRÊMIO DIVERGENTE';
                    else if (strStatus == "DADOS_DO_TOMADOR_DIVERGENTE")
                        return 'DADO DO TOMADOR DIVERGENTE';
                    else if (strStatus == "SEM_CNAE_HABILITADO")
                        return 'SEM CNAE HABILITADO';
                    else if (strStatus == "COD_DE_SERVICO_DIVERGENTE_DO_CNAE")
                        return 'COD. DE SERVIÇO DIVERGENTE DO CNAE';
                    else
                        return "";
                }
                else {
                    return "";
                }


            },


            returnDate: function (time) {
                //função cria data baseado na quantidade de dias a mais ou a menos baseado na data atual
                var dt = new Date();
                var d = new Date(dt.setDate(dt.getDate() - time));
                //formata data para padrao dd/mm/yyyy
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();
                // return datestring;
                return d.toISOString();
            },
            uploadNf: function () {
                let div = document.createElement('div')
                const title = 'Atenção!'
                const text = 'Prezado Integrador, Agradecemos por sua confiança em nossa parceria. Para garantir a segurança de suas informações e evitar qualquer erro durante o processo, solicitamos que em caso de primeiro recebimento de comissão e  <b>mudanças na conta bancária de recebimento</b>, nos envie o número da agência e conta atualizados através de nossos e-mails oficiais cadastro@aldo.com.br e cpagar@aldo.com.br. Os pagamentos somente serão realizados em notas fiscais que foram enviadas pelo nosso site através de upload, serão desconsideradas as notas fiscais enviadas por e-mail. Agradecemos sua compreensão e colaboração para garantir a segurança de suas informações pessoais e financeiras. Atenciosamente,'
                div.innerHTML = text
                swal({
                    title, 
                    content: div,
                    icon: 'warning',
                    buttons: ['Cancelar', 'Confirmar Envio'],
                }).then((confirmou)=> {
                
                    if(confirmou){
                        //Método para enviar o arquivo
                        var xhr = new XMLHttpRequest();
                        //Chamar esse métdodo quando mandar a requisição para enviar o arquivo
                        this.uploadingStatus();

                        var arquivo = this.formFilter.file.value;
                        var nomeArquivo = this.formFilter.file;

                        if (this.formFilter.file.size > 2097 * 1000) {
                            swal({
                                title: "Tamanho máximo de arquivo: 2MB",
                                icon: "error"
                            });
                            this.formFilter.file.value = "";
                        }
                        else {
                            xhr.onload = () => {
                                if (xhr.status == 201) {
                                    //Chamar esse swal caso o retorno seja sucesso (2xx)
                                    swal({
                                        title: "Arquivo enviado com sucesso!",
                                        content: {
                                            element: "div",
                                            attributes: {
                                                innerHTML: `
                                                    <div style="text-align: left; margin-top: 10px; border: 2px solid #4ea7e8; border-radius: 8px; padding: 10px;">
                                                        <div style="display: flex; align-items: center;">
                                                            <span style="font-size: 24px; color: #f39c12; margin-right: 10px;">⚠️</span>
                                                            <p style="font-size: 14px; margin: 0; text-align: justify;">
                                                                Após o envio da sua nota fiscal, realizaremos a verificação em até 
                                                                <strong>7 dias úteis</strong>. Após isso, informaremos a previsão de pagamento.
                                                            </p>
                                                        </div>
                                                    </div>
                                                `
                                            }
                                        },
                                        icon: "success",
                                        button: "OK",
                                    });
                                    //Chamar esse método depois do sucesso do envio para limpar o arquivo e liberar o input para novos uploads
                                    this.formFilter.file.value = "";
                                }
                                else if (xhr.status == 401) {
                                    swal({
                                        title: "Usuário precisa estar logado para enviar notas fiscais!",
                                        icon: "warning"
                                    });
                                }
                                else if (xhr.status == 403) {
                                    swal({
                                        title: "Não foi possível enviar o arquivo. Tente novamente mais tarde ou entre em contato com seu vendedor.",
                                        icon: "warning"
                                    });
                                    //Chamar esse método depois do sucesso do envio para limpar o arquivo e liberar o input para novos uploads
                                    this.formFilter.file.value = "";
                                }
                                else if (xhr.status == 406) {
                                    swal({
                                        title: "Verifique a extensão do arquivo",
                                        text: "só serão aceitos: .jpg, .gif, .png, .pdf ou .xml",
                                        icon: "warning"
                                    });
                                    //Chamar esse método depois do sucesso do envio para limpar o arquivo e liberar o input para novos uploads
                                    this.formFilter.file.value = "";
                                }
                                else {
                                    //Chamar esse swal caso o retorno seja falha (4xx, 5xx e etc...)
                                    swal({
                                        title: "Erro ao enviar arquivo!",
                                        icon: "error"
                                    });
                                    this.formFilter.file.value = "";
                                }
                            }
                            xhr.open("POST", this.$apiUrl + "Financeiro.svc/uploadnota");
                            xhr.setRequestHeader("Content-Type", "application/json");
                            xhr.withCredentials = true;
                            this.searchingStatus();
                            xhr.send(JSON.stringify({ nomeArquivo: this.formFilter.file.name, tipoDocumento: this.formFilter.file.tipo, bytesArquivo: arquivo }));
                        }
                    }
                });
                
            },
            uploadingStatus: function () {
                //Desabilita o botão de upload e o input para que não remova ou selecione outro arquivo durante o upload
                this.isUploading = true;
                jQuery("#files").css("pointer-events", "none");
            },
            disableUpload: function () {
                //Desabilita o botão de upload de arquivo quando não há arquivo selecionado
                this.isUploading = false;
                jQuery("#btn-upnf").prop("disabled", true);
                jQuery("#files").css("pointer-events", "auto");
            },
            enableUpload: function () {
                //Habilita o botão de upload de arquivo quando há arquivo selecionado
                this.isUploading = false;
                jQuery("#btn-upnf").prop("disabled", false);
                jQuery("#files").css("pointer-events", "auto");
            },
            search: function () {
                const self = this;
                this.formFilter.attemptSubmit = true;
                if (this.formErrors > 0) {
                    return;
                }
                var obj = {};
                obj.dataInicial = this.formFilter.dataInicial.value;
                obj.dataFinal = this.formFilter.dataFinal.value;
                if (this.formFilter.situacao.value == "Todos") {
                    obj.situacao = 2;
                } else {
                    obj.situacao = this.formFilter.situacao.value.code;
                }
                obj.filial = 1;

                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    if (xhr.readyState == 4) {
                        self.normalStatus();
                        if (xhr.status == 200) {
                            let json = JSON.parse(xhr.responseText);
                            self.fillTable(json);
                        } else {
                            self.fillTable({});
                        }
                    }
                }
                xhr.open("POST", this.$apiUrl + "Financeiro.svc/retornacomissoes");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                this.searchingStatus();
                xhr.send(JSON.stringify(obj));
            },
            searchingStatus: function () {
                var $btnIcon = jQuery("#btn-icon");
                $btnIcon.removeClass("fa-search");
                $btnIcon.addClass("fa-spinner fa-spin");
                jQuery("#btn-search").prop("disabled", true);
            },
            normalStatus: function () {
                var $btnIcon = jQuery("#btn-icon");
                $btnIcon.removeClass("fa-spinner fa-spin");
                $btnIcon.addClass("fa-search");
                jQuery("#btn-search").prop("disabled", false);
            },
            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
                    // Para que o usuário seja barrado em caso de um submit sem dados
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },
            getFiliais: function () {
                const filiais = [
                    { code: 1, label: "Paraná" },
                    { code: 2, label: "Espirito Santo" }
                ];

                return filiais;
            },
            getStatus: function () {
                const status = [
                    { code: 0, label: "Pagos" },
                    { code: 1, label: "Não Pagos" },
                    { code: 3, label: "Liberados para Pagamento" },
                    { code: 2, label: "Todos" }
                ];

                return status;
            },
            fillTable: function (dados) {
                const self = this;
                var formattedRows = [];
                if (!jQuery.isEmptyObject(dados)) {
                    dados.Comissoes.forEach(function (element) {
                        element.Items.forEach(function (childrenElement) {
                            const child = childrenElement;
                            var row = [];
                            row.push(self.formatRowItem(self.formatCodigo(child), false, self.formatLink(child)));
                            row.push(self.formatRowItem(child.NotaFiscal));
                            row.push(self.formatRowItem(child.DataNotaFiscal));
                            row.push(self.formatRowItem(child.DataVencimento));
                            row.push(self.formatRowItem(child.Quitacao));
                            row.push(self.formatRowItem(self.formatCurrency(child.ValorNota)));
                            row.push(self.formatRowItem(child.CnpjCliente));
                            row.push(self.formatRowItem(child.Cidade));
                            row.push(self.formatRowItem(self.formatCurrency(child.TotalPagar)));
                            row.push(self.formatRowItem(child.Situacao));
                            row.push(self.formatRowItem(child.NotaPrest));
                            row.push(self.formatRowItem(child.DataQuitacao));
                            row.push(self.formatRowItem(child.SituacaoUpload));
                            formattedRows.push(row);
                        });
                        formattedRows.push(self.createTotalRow(element.SomaQuinzena, "TOTAL"));
                    });
                    formattedRows.push(self.createBlankRow());
                    formattedRows.push(self.createTotalRow(dados.ValorPagos, "PAGOS(" + dados.QtdePagos + ")"));
                    formattedRows.push(self.createTotalRow(dados.ValorTotalNf, "TOTAL DAS NF(" + dados.QtdeTotalNf + ")"));
                } else {
                    var row = self.createBlankRow();
                    row[0] = self.formatRowItem("Sem dados");
                    formattedRows.push(row);
                    formattedRows.push(self.createBlankRow());
                }
                this.rows = formattedRows
            },
            createBlankRow: function () {
                //Cria linha em branco
                const self = this;
                var row = [];
                for (let i = 0; i < 12; i++) {
                    row.push(self.formatRowItem());
                }
                return row;
            },
            createTotalRow: function (value, label) {
                //Cria a linha em negrito com os totais na tabela
                const self = this;
                var row = [];
                for (let i = 0; i < 7; i++) {
                    row.push(self.formatRowItem());
                }
                row.push(this.formatRowItem(label, true));
                row.push(this.formatRowItem(self.formatCurrency(value), true));
                for (let i = 0; i < 4; i++) {
                    row.push(self.formatRowItem());
                }
                return row;
            },
            formatCodigo: function (element) {
                //Formata o código  do pedido e da venda para a tabela
                return element.CodigoPedidoVendaDireta + "-" + element.CodigoPedidoVendaDiretaDv + "/"
                    + element.CpvdCodigoVendaDireta + "-" + element.CpvdCodigoVendaDiretaDv;
            },
            formatLink: function (element) {
                //Formata o código  do pedido e da venda para a tabela
                return '/detalhes-do-pedido/' + element.CpvdCodigoVendaDireta + '/' + 'V'
            },

            formatRowItem(value, bold, link, status) {
                //Cria o objeto que será item na tabela
                return { bold: bold, value: value, href: link }
            },
            formatCurrency: function (v) {
                v = v.toString().replace(',', '.')
                //Formata coluna de valores da tabela para moeda
                var formato = {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL"
                };
                return parseFloat(v).toLocaleString("pt-BR", formato);
            },
            formatPrice: function (value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            getDados: function () {
                const dados = {
                    Comissoes: [
                        {
                            Items: [
                                {
                                    Cidade: "MARINGA",
                                    CnpjCliente: "72042799000190",
                                    CodigoPedidoVendaDireta: "418268",
                                    CodigoPedidoVendaDiretaDv: "8",
                                    CpvdCodigoVendaDireta: "912055",
                                    CpvdCodigoVendaDiretaDv: "8",
                                    DataNotaFiscal: "10/11/2009",
                                    DataQuitacao: "10/11/2009 00:00:00",
                                    DataVencimento: "02/10/2009 00:00:00",
                                    NotaFiscal: "61960",
                                    NotaPrest: "16578",
                                    Programa: "DIRECT SELLING",
                                    Quitacao: "01/10/2009 00:00:00",
                                    Situacao: "PAGO",
                                    TotalPagar: 61.52,
                                    ValorNota: 672.00
                                }
                            ],
                            Quinzena: "0",
                            SomaQuinzena: 61.52
                        },
                        {
                            Items: [
                                {
                                    Cidade: "MARINGA",
                                    CnpjCliente: "79114450000165",
                                    CodigoPedidoVendaDireta: "469207",
                                    CodigoPedidoVendaDiretaDv: "7",
                                    CpvdCodigoVendaDireta: "960901",
                                    CpvdCodigoVendaDiretaDv: "3",
                                    DataNotaFiscal: "08/04/2010",
                                    DataQuitacao: "08/04/2010 00:00:00",
                                    DataVencimento: "25/03/2010 00:00:00",
                                    NotaFiscal: "103107",
                                    NotaPrest: "16942",
                                    Programa: "DIRECT SELLING",
                                    Quitacao: "25/03/2010 00:00:00",
                                    Situacao: "PAGO",
                                    TotalPagar: 417.15,
                                    ValorNota: 7875.00
                                }
                            ],
                            Quinzena: "1",
                            SomaQuinzena: 417.15
                        },
                        {
                            Items: [
                                {
                                    Cidade: "MARINGA",
                                    CnpjCliente: "04792670000149",
                                    CodigoPedidoVendaDireta: "1216179",
                                    CodigoPedidoVendaDiretaDv: "1",
                                    CpvdCodigoVendaDireta: "1819275",
                                    CpvdCodigoVendaDiretaDv: "4",
                                    DataNotaFiscal: "08/06/2016",
                                    DataQuitacao: "08/06/2016 00:00:00",
                                    DataVencimento: "03/05/2016 00:00:00",
                                    NotaFiscal: "714205",
                                    NotaPrest: "263",
                                    Programa: "DIRECT SELLING",
                                    Quitacao: "03/05/2016 00:00:00",
                                    Situacao: "PAGO",
                                    TotalPagar: 221.13,
                                    ValorNota: 1798.00
                                },
                                {
                                    Cidade: "MARINGA",
                                    CnpjCliente: "03459850000140",
                                    CodigoPedidoVendaDireta: "1322556",
                                    CodigoPedidoVendaDiretaDv: "6",
                                    CpvdCodigoVendaDireta: "1927574",
                                    CpvdCodigoVendaDiretaDv: "3",
                                    DataNotaFiscal: "09/03/2017",
                                    DataQuitacao: "09/03/2017 00:00:00",
                                    DataVencimento: "08/02/2017 00:00:00",
                                    NotaFiscal: "797692",
                                    NotaPrest: "355",
                                    Programa: "DIRECT SELLING",
                                    Quitacao: "08/02/2017 00:00:00",
                                    Situacao: "PAGO",
                                    TotalPagar: 2215.57,
                                    ValorNota: 45224.97
                                }
                            ],
                            Quinzena: "0",
                            SomaQuinzena: 2436.7000000000003
                        }
                    ],
                    QtdePagos: 4,
                    QtdeTotalNf: 4,
                    ValorPagos: 2915.37,
                    ValorTotalNf: 2915.37
                };
                return dados;
            }
        }
    };

</script>
